// Constants
import { MODULE_SIZE_TO_SIZE_FILTER } from '../constants';
import { CustomPDFReportModuleSize, } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/enums/custom-pdf-report-module.enum';
export const getPageNum = (moduleOrPageElement) => {
    return parseInt(moduleOrPageElement.dataset.page, 10);
};
export const getCoordinates = (moduleOrPageElement, item) => {
    if (moduleOrPageElement.dataset.validmodules && item.dataset.width && item.dataset.size) {
        const validModules = JSON.parse(moduleOrPageElement.dataset.validmodules);
        const pageWidth = parseInt(item.dataset.width, 10);
        const pageSize = parseInt(item.dataset.size, 10);
        const validModule = validModules.find((size) => size.pageWidth === pageWidth && size.pageSize === pageSize);
        if (validModule) {
            return { x: validModule.x, y: validModule.y };
        }
    }
    return null;
};
export const getPageNumFromPageId = (pageId) => {
    return parseInt(pageId.replace('pdf-page-', '').split('-')[0], 10);
};
export const getModuleSize = (moduleElement) => {
    return parseInt(moduleElement.dataset.size, 10);
};
export const getCustomizableFieldValues = (fields) => {
    return Object.keys(fields).reduce((acc, fieldName) => {
        acc[fieldName] = fields[fieldName].value;
        return acc;
    }, {});
};
export const convertModulesToSaveState = (modules) => {
    return modules.map((page) => {
        return page.map((module) => {
            return {
                ...module,
                // Ignore module field metadata and reduce customizable fields to their values
                customizable_fields: getCustomizableFieldValues(module.customizable_fields),
            };
        });
    });
};
export const getFiltersFromAllowedModuleSizes = (allowedModuleSizes) => {
    const all = allowedModuleSizes.length === Object.keys(CustomPDFReportModuleSize).length;
    const filters = {
        [CustomPDFReportModuleSize.PAGE_SIZE_QUARTER]: false,
        [CustomPDFReportModuleSize.PAGE_SIZE_THIRD]: false,
        [CustomPDFReportModuleSize.PAGE_SIZE_HALF]: false,
        [CustomPDFReportModuleSize.PAGE_SIZE_ONE]: false,
        all,
    };
    if (!all) {
        allowedModuleSizes.forEach((moduleSize) => {
            filters[MODULE_SIZE_TO_SIZE_FILTER[moduleSize]] = true;
        });
    }
    return filters;
};
export const getTearsheetFiltersFromAllowedModuleSizes = (allowedModuleSizes, allModuleSizes) => {
    const all = allowedModuleSizes.length === allModuleSizes.length;
    let filters = {
        all,
    };
    allModuleSizes.forEach((moduleSize) => {
        filters = {
            ...filters,
            [moduleSize]: false,
        };
    });
    if (!all) {
        allowedModuleSizes.forEach((moduleSize) => {
            filters[moduleSize] = true;
        });
    }
    return filters;
};
